import AsyncDropdown from 'core/elements/dropdown/AsyncDropdown'
import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import { capitalizeString } from 'utils/misc'

export interface VolumeStatusPicklist {
  label: string
  value: string
}
const AVAILABLE_STATES = ['available', 'error', 'in-use', 'maintenance']

export function VolumeStatusPickList({ currentStatus, volume, ...props }) {
  const classes = useStyles()
  const items = useMemo(() => {
    const isAttached = !!volume?.attachments?.length // add attachement check

    // Allowed states depending on whether volume is attached
    let allowedStates = AVAILABLE_STATES.filter((state) => {
      // Exclude 'in-use' if the volume is not attached
      if (!isAttached && state === 'in-use') return false
      return true
    })

    // Remove current status from options
    allowedStates = allowedStates?.filter((state) => state !== currentStatus)

    return allowedStates?.map((state) => ({
      value: state,
      label: capitalizeString(state),
    }))
  }, [currentStatus, volume])

  return (
    <AsyncDropdown compact items={items} value={''} className={classes.customDropdown} {...props} />
  )
}
export default VolumeStatusPickList

const useStyles = makeStyles((theme: Theme) => ({
  customDropdown: {
    '& .placeholder': {
      fontWeight: 400,
    },
    '& .dropdownMenu': {
      maxHeight: 250,
    },
  },
}))
